const MARKET_TOKEN = ':market([\\w\\-]+)/';
const MARKET_TOKEN_DW = ':market(Destination-Weddings)/';
const MARKET_TOKEN_CI = ':market(Caribbean-Islands)/';
const SUB_MARKET_TOKEN = ':submarket([\\w\\-]+)/';
const REGION_TOKEN = ':region([\\w\\-]+)/';
const CITY_TOKEN = ':city([\\w\\-]+)/';
const ZIPCODE_TOKEN = ':zipcode(\\d{5})/';
const STYLE_TOKEN_GENERIC = ':style([\\w\\-]+)-wedding-venues/';
const STYLE_TOKEN = ':style([\\w\\-]+)-Weddings/';
const RD_STYLE_TOKEN = ':style([\\w\\-]+)-Rhearsal-Dinners-Bridal-Showers/';

export const SRP_BASE = '/wedding-venues/';
export type SRP_BASE = typeof SRP_BASE;

export const SRP_MARKET = `${SRP_BASE}${MARKET_TOKEN}`;
export type SRP_MARKET = typeof SRP_MARKET;

export const SRP_MARKET_DW = `${SRP_BASE}${MARKET_TOKEN_DW}`;
export type SRP_MARKET_DW = typeof SRP_MARKET_DW;

export const SRP_MARKET_CI = `${SRP_BASE}${MARKET_TOKEN_CI}`;
export type SRP_MARKET_CI = typeof SRP_MARKET_CI;

export const SRP_REGION = `${SRP_BASE}${MARKET_TOKEN}${REGION_TOKEN}`;
export type SRP_REGION = typeof SRP_REGION;

export const SRP_CITY = `${SRP_BASE}${MARKET_TOKEN}${CITY_TOKEN}`;
export type SRP_CITY = typeof SRP_CITY;

export const SRP_SUB_MARKET = `${SRP_BASE}${MARKET_TOKEN}${SUB_MARKET_TOKEN}`;
export type SRP_SUB_MARKET = typeof SRP_SUB_MARKET;

export const SRP_SUB_MARKET_DW = `${SRP_BASE}${MARKET_TOKEN_DW}${SUB_MARKET_TOKEN}`;
export type SRP_SUB_MARKET_DW = typeof SRP_SUB_MARKET_DW;

export const SRP_SUB_MARKET_CI = `${SRP_BASE}${MARKET_TOKEN_CI}${SUB_MARKET_TOKEN}`;
export type SRP_SUB_MARKET_CI = typeof SRP_SUB_MARKET_CI;

export const SRP_STYLE_GENERIC = `/${STYLE_TOKEN_GENERIC}`;
export type SRP_STYLE_GENERIC = typeof SRP_STYLE_GENERIC;

export const SRP_BASE_STYLE = `${SRP_BASE}${STYLE_TOKEN}`;
export type SRP_BASE_STYLE = typeof SRP_BASE_STYLE;

export const SRP_STYLE_MARKET = `${SRP_BASE_STYLE}${MARKET_TOKEN}`;
export type SRP_STYLE_MARKET = typeof SRP_STYLE_MARKET;

export const SRP_STYLE_REGION = `${SRP_BASE_STYLE}${MARKET_TOKEN}${REGION_TOKEN}`;
export type SRP_STYLE_REGION = typeof SRP_STYLE_REGION;

export const SRP_STYLE_SUB_MARKET = `${SRP_BASE_STYLE}${MARKET_TOKEN}${SUB_MARKET_TOKEN}`;
export type SRP_STYLE_SUB_MARKET = typeof SRP_STYLE_SUB_MARKET;

export const SRP_ZIP_CODE = `${SRP_BASE}${ZIPCODE_TOKEN}`;
export type SRP_ZIP_CODE = typeof SRP_ZIP_CODE;

export const SRP_AFFORDABLE_BASE = '/affordable-wedding-venues/';
export type SRP_AFFORDABLE_BASE = typeof SRP_AFFORDABLE_BASE;

export const SRP_AFFRODABLE_MARKET = `${SRP_AFFORDABLE_BASE}${MARKET_TOKEN}`;
export type SRP_AFFRODABLE_MARKET = typeof SRP_AFFRODABLE_MARKET;

export const SRP_AFFRODABLE_REGION = `${SRP_AFFORDABLE_BASE}${MARKET_TOKEN}${REGION_TOKEN}`;
export type SRP_AFFRODABLE_REGION = typeof SRP_AFFRODABLE_REGION;

export const SRP_AFFRODABLE_CITY = `${SRP_AFFORDABLE_BASE}${MARKET_TOKEN}${CITY_TOKEN}`;
export type SRP_AFFRODABLE_CITY = typeof SRP_AFFRODABLE_CITY;

export const SRP_AFFRODABLE_SUB_MARKET = `${SRP_AFFORDABLE_BASE}${MARKET_TOKEN}${SUB_MARKET_TOKEN}`;
export type SRP_AFFRODABLE_SUB_MARKET = typeof SRP_AFFRODABLE_SUB_MARKET;

export const SRP_RD_BASE = `/rehearsal-dinners-bridal-showers/`;
export type SRP_RD_BASE = typeof SRP_RD_BASE;

export const SRP_RD_MARKET = `${SRP_RD_BASE}${MARKET_TOKEN}`;
export type SRP_RD_MARKET = typeof SRP_RD_MARKET;

export const SRP_RD_REGION = `${SRP_RD_BASE}${MARKET_TOKEN}${REGION_TOKEN}`;
export type SRP_RD_REGION = typeof SRP_RD_REGION;

export const SRP_RD_CITY = `${SRP_RD_BASE}${MARKET_TOKEN}${CITY_TOKEN}`;
export type SRP_RD_CITY = typeof SRP_RD_CITY;

export const SRP_RD_SUB_MARKET = `${SRP_RD_BASE}${MARKET_TOKEN}${SUB_MARKET_TOKEN}`;
export type SRP_RD_SUB_MARKET = typeof SRP_RD_SUB_MARKET;

export const SRP_RD_STYLE_BASE = `${SRP_RD_BASE}${RD_STYLE_TOKEN}`;
export type SRP_RD_STYLE_BASE = typeof SRP_RD_STYLE_BASE;

export const SRP_RD_STYLE_MARKET = `${SRP_RD_BASE}${RD_STYLE_TOKEN}${MARKET_TOKEN}`;
export type SRP_RD_STYLE_MARKET = typeof SRP_RD_STYLE_MARKET;

export const SRP_RD_STYLE_REGION = `${SRP_RD_BASE}${RD_STYLE_TOKEN}${MARKET_TOKEN}${REGION_TOKEN}`;
export type SRP_RD_STYLE_REGION = typeof SRP_RD_STYLE_REGION;

export const SRP_RD_STYLE_SUB_MARKET = `${SRP_RD_BASE}${RD_STYLE_TOKEN}${MARKET_TOKEN}${SUB_MARKET_TOKEN}`;
export type SRP_RD_STYLE_SUB_MARKET = typeof SRP_RD_STYLE_SUB_MARKET;

export const SRP_RD_ZIPCODE = `${SRP_RD_BASE}${ZIPCODE_TOKEN}`;
export type SRP_RD_ZIPCODE = typeof SRP_RD_ZIPCODE;

// URL patters for all "vanilla" SRPs with no modifiers like RD/Affordable
// Order matters here, zip code is above market because, the market regex is a superset of the zipcode regex
export const BASE_SRP_URLS = [
    SRP_STYLE_GENERIC,
    SRP_BASE,
    SRP_ZIP_CODE,
    SRP_MARKET_DW,
    SRP_SUB_MARKET_DW,
    SRP_MARKET_CI,
    SRP_SUB_MARKET_CI,
    SRP_BASE_STYLE,
    SRP_STYLE_MARKET,
    SRP_STYLE_REGION,
    SRP_STYLE_SUB_MARKET,
    SRP_MARKET,
    SRP_REGION,
    SRP_SUB_MARKET,
];

// URL patterns for all affordable SRPs
export const AFFORDABLE_SRP_URLS = [SRP_AFFORDABLE_BASE, SRP_AFFRODABLE_MARKET, SRP_AFFRODABLE_REGION, SRP_AFFRODABLE_SUB_MARKET];

// URL patters for all RD SRPs
// Order matters here, zip code is above market because, the market regex is a superset of the zipcode regex
export const RD_SRP_URLS = [
    SRP_RD_BASE,
    SRP_RD_ZIPCODE,
    SRP_RD_STYLE_BASE,
    SRP_RD_STYLE_MARKET,
    SRP_RD_STYLE_REGION,
    SRP_RD_STYLE_SUB_MARKET,
    SRP_RD_MARKET,
    SRP_RD_REGION,
];

export const ALL_SRP_URLS = [...BASE_SRP_URLS, ...AFFORDABLE_SRP_URLS, ...RD_SRP_URLS];
